import { useMemo } from "react";
import Chart from "react-apexcharts";
import TimeUtils from "utils/time";
import TreemapUtils from "utils/treemap";
import AnalyticsService from "data/firestore/analytics";
import { MethodColors, MethodCategories } from "data/methods";

const getCategoryColor = (categoryName) => {
  const palette =
    MethodColors[categoryName] || MethodColors[MethodCategories.Other];
  return palette[500] || "#6c757d";
};

export default function MethodsTreemap({
  categories,
  methods,
  grouped = true,
}) {
  const series = useMemo(() => {
    if (grouped) {
      // Categories only: one block per category, each with its own color
      return [
        {
          name: "Categories",
          data: categories.map((c) => ({
            x: c.name,
            y: c.value,
            fillColor: getCategoryColor(c.name),
          })),
        },
      ];
    }
    // Breakdown: individual methods grouped by category
    return TreemapUtils.buildSeries(categories, methods);
  }, [categories, methods, grouped]);

  const total = TreemapUtils.calculateTotal(methods);

  const options = {
    chart: {
      type: "treemap",
      height: 350,
      toolbar: { show: false },
    },
    legend: {
      show: !grouped, // legend only useful when showing grouped breakdown
    },
    tooltip: {
      y: {
        formatter: (value, { seriesIndex, dataPointIndex, w }) => {
          const methodName =
            w.config.series[seriesIndex].data[dataPointIndex].x;
          const percentage = TreemapUtils.formatPercentage(value, total);
          const timeString = TimeUtils.elapsedToString(
            TimeUtils.breakdown(value, true),
            2
          );

          AnalyticsService.throttleChartHover(
            "hover_method_treemap",
            { method: methodName, value: value, percentage: percentage },
            `${methodName} ${timeString}`
          );

          return `${timeString} (${percentage}%)`;
        },
      },
    },
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Chart options={options} series={series} type="treemap" height="100%" />
    </div>
  );
}
